"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateArtifactKey = exports.ARTIFACT_ID_REGEX = exports.GROUP_ID_REGEX = void 0;
const artifact_description_error_1 = require("./artifact-description-error");
exports.GROUP_ID_REGEX = /^[a-z][a-z0-9-]*(\.[a-z][a-z0-9-]*)*$/;
exports.ARTIFACT_ID_REGEX = /^[a-z][a-z0-9]*(-[a-z0-9]*)*$/;
const LENGTH_LIMIT = 200;
function validateArtifactKey(key, fileName, dir) {
    if (!key.groupId) {
        throw new artifact_description_error_1.ArtifactDescriptionError(`Missing group ID (file: ${fileName}, directory: ${dir})`);
    }
    if (typeof key.groupId !== 'string') {
        throw new artifact_description_error_1.ArtifactDescriptionError(`Bad group ID: it must be a string (file: ${fileName}, directory: ${dir})`);
    }
    if (!key.artifactId) {
        throw new artifact_description_error_1.ArtifactDescriptionError(`Missing artifact ID (file: ${fileName}, directory: ${dir})`);
    }
    if (typeof key.artifactId !== 'string') {
        throw new artifact_description_error_1.ArtifactDescriptionError(`Bad artifact ID: it must be a string (file: ${fileName}, directory: ${dir})`);
    }
    if (key.artifactId.length > LENGTH_LIMIT) {
        throw new artifact_description_error_1.ArtifactDescriptionError(`Bad artifact ID value: length limit exceeded (file: ${fileName}, directory: ${dir})`);
    }
    if (key.groupId.length > LENGTH_LIMIT) {
        throw new artifact_description_error_1.ArtifactDescriptionError(`Bad group ID value: length limit exceeded (file: ${fileName}, directory: ${dir})`);
    }
    if (!key.groupId.match(exports.GROUP_ID_REGEX)) {
        throw new artifact_description_error_1.ArtifactDescriptionError(`Bad group ID value "${key.groupId}" (file: ${fileName}, directory: ${dir})`);
    }
    if (!key.artifactId.match(exports.ARTIFACT_ID_REGEX)) {
        throw new artifact_description_error_1.ArtifactDescriptionError(`Bad artifact ID value "${key.artifactId}" (file: ${fileName}, directory: ${dir})`);
    }
    return key;
}
exports.validateArtifactKey = validateArtifactKey;
//# sourceMappingURL=artifact-key.js.map